module.exports = __webpack_public_path__ + "static/media/datasentics-logo-blue.714554c8.png";